import React, { useState } from "react";
import { toast } from "react-toastify";

import PopoverPopupState from "./../Esnad/Details";

import styles from "./../../styles/azkar.module.css";
import { useNavigate } from "react-router-dom";

const evningAzkar = {
  hold: {
    text: `الحَمْـدُ لِلّهِ الّذي أَحْـيانا بَعْـدَ ما أَماتَـنا وَإليه النُّـشور`,
    count: 1,
    Details: `عن أبو داود واللفظ له، والترمذي وقال حسن صحيح غريب، والنسائي عن عبد الله بن خبيب رضي الله عنه قال: قال رسول الله صلى الله عليه وسلم: قل، قلت يا رسول الله ما أقول؟ قال: قل هو الله أحد، والمعوذتين حين تمسي وحين تصبح ثلاث مرات تكفيك من كل شيء`,
  },
  Falaq: {
    text: `الحمدُ للهِ الذي عافاني في جَسَدي وَرَدّ عَليّ روحي وَأَذِنَ لي بِذِكْرِه`,
    count: 1,
    Details: `ورد هذا الأمر في ” سنن الترمذي ” حديث رقم: (3924) – حَدَّثَنَا عَبْدُ بْنُ حُمَيْدٍ ، قَالَ : حَدَّثَنَا مُحَمَّدُ بْنُ إِسْمَاعِيلَ بْنِ أَبِي فُدَيْكٍ ، قَالَ : حَدَّثَنَا ابْنُ أَبِي ذِئْبٍ ، عَنْ أَبِي سَعِيدٍ البَرَّادِ ، عَنْ مُعَاذِ بْنِ عَبْدِ اللهِ بْنِ خُبَيْبٍ ، عَنْ أَبِيهِ ، قَالَ : خَرَجْنَا فِي لَيْلَةٍ مَطِيرَةٍ وَظُلْمَةٍ شَدِيدَةٍ نَطْلُبُ رَسُولَ اللهِ صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ يُصَلِّي لَنَا ، قَالَ : فَأَدْرَكْتُهُ ، فَقَالَ : قُلْ فَلَمْ أَقُلْ شَيْئًا ، ثُمَّ قَالَ : قُلْ ، فَلَمْ أَقُلْ شَيْئًا ، قَالَ : قُلْ ، فَقُلْتُ ، مَا أَقُولُ ؟ قَالَ : قُلْ : قُلْ هُوَ اللَّهُ أَحَدٌ ، وَالمُعَوِّذَتَيْنِ حِينَ تُمْسِي وَتُصْبِحُ ثَلاَثَ مَرَّاتٍ تَكْفِيكَ مِنْ كُلِّ شَيْءٍ.`,
  },
  people: {
    text: `لا إلهَ إلاّ اللّهُ وَحْـدَهُ لا شَـريكَ له، لهُ المُلـكُ ولهُ الحَمـد، وهوَ على كلّ شيءٍ قدير، سُـبْحانَ اللهِ، والحمْـدُ لله ، ولا إلهَ إلاّ اللهُ واللهُ أكبَر، وَلا حَولَ وَلا قوّة إلاّ باللّهِ العليّ العظيم. رَبِّ اغْفرْ لي`,
    count: 1,
    Details: `فعن عبد الله بن خبيب -رضي الله عنه- عن النبيّ -صلّى الله عليه وسلّم- قال: (خرجنا في ليلةِ مَطَرٍ وظُلْمَةٍ شديدةٍ نطلبُ رسولَ اللهِ صلى الله عليه وسلم لِيُصليَ لنا، فأدركناه، فقال: أصليتم؟ فلم أقلْ شيئًا، فقال: قلْ. فلم أقلْ شيئًا، ثم قال: قلْ. فلم أقلْ شيئًا، ثم قال: قلْ: فقلتُ: يا رسولَ اللهِ، ما أقولُ؟ قال: قل هو الله أحد والمُعَوِّذَتين حينَ تُمسي وحينَ تُصبحُ ثلاثَ مراتٍ تُكفيك مِن كلِّ شيءٍ)`,
  },
};

function GettingUpCount() {
  // this is 1
  const [count1, setCount1] = useState(evningAzkar.hold.count);
  const [count2, setCount2] = useState(evningAzkar.Falaq.count);
  const [count3, setCount3] = useState(evningAzkar.people.count);
  const [countDone, setCountDone] = useState(false);

  let navigate = useNavigate();

  const done1 = () => {
    count1 > 0 && setCount1(count1 - 1);
  };

  const done2 = () => {
    count2 > 0 && setCount2(count2 - 1);
    // if (!countDone) {
    //   if (count2 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done3 = () => {
    count3 > 0 && setCount3(count3 - 1);
    if (!countDone) {
      if (count3 === 1) {
        setCountDone(true);
        toast.success(
          "لقد اتممت اذكار الاستيقاظ , فتح الله عليك و تقبل منك صالح الاعمال♥",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        navigate("/");
      }
    }
  };
  // Chack Text
  const azkarNow = () => {
    if (count1 >= 1) {
      return evningAzkar.hold.text;
    } else if (count1 <= 1 && count2 >= 1) {
      return evningAzkar.Falaq.text;
    } else if (count2 <= 1 && count3 >= 1) {
      return evningAzkar.people.text;
    }   else {
      return `لقد اتممت اذكار المساء لا تنسي اذكار الصباح ♥♥♥`;
    }
  };

  // Chack Text
  const DetailsAzkarNow = () => {
    if (count1 >= 1) {
      return evningAzkar.hold.Details;
    } else if (count1 <= 1 && count2 >= 1) {
      return evningAzkar.Falaq.Details;
    } else if (count2 <= 1 && count3 >= 1) {
      return evningAzkar.people.Details;
    }  else {
      return `لقد اتممت اذكار الاستيقاذ لا تنسي اذكار الصباح ♥♥♥`;
    }
  };

  // Chack Action
  const actionNow = () => {
    if (count1 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done1}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count1 >= 0 && `${evningAzkar.hold.count} / ${count1}`}
            </div>
          </button>
        </div>
      );
    } else if (count1 <= 1 && count2 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done2}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count2 >= 0 && `${evningAzkar.Falaq.count} / ${count2}`}
            </div>
          </button>
        </div>
      );
    } else if (count2 <= 1 && count3 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done3}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count3 >= 0 && `${evningAzkar.people.count} / ${count3}`}
            </div>
          </button>
        </div>
      );
    }  else {
      return null;
    }
  };
  return (
    <div className="relative ">
      {/*  */}
      <div className="flex justify-end mt-5 container">
        <div className="flex  z-40 justify-between mx-2 align-items-center row gap-4">
          <div className={`col-md-4 col-lg-8 px-2  py-2 ${styles.leftAzkar}`}>
            <h5 className="mb-0">{azkarNow()}</h5>
            <div className="text-start px-4">
              <PopoverPopupState text={DetailsAzkarNow()} />
            </div>
          </div>
          {actionNow()}
        </div>
      </div>
    </div>
  );
}

export default GettingUpCount;
